var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClosed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8633 30.0392H2.55945C2.23342 30.0392 1.91192 29.8994 1.66836 29.6358C1.42356 29.3708 1.27991 29.0036 1.27991 28.6133V2.20104C1.27991 1.81068 1.42356 1.44348 1.66835 1.17855C1.91192 0.914956 2.23342 0.775146 2.55945 0.775146H20.8633C21.1894 0.775146 21.5109 0.914955 21.7544 1.17855C21.9992 1.44348 22.1429 1.81068 22.1429 2.20104V28.6133C22.1429 29.0036 21.9992 29.3708 21.7544 29.6358C21.5109 29.8994 21.1894 30.0392 20.8633 30.0392Z",
    fill: "white",
    stroke: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55946 0.550255C2.15492 0.550255 1.76695 0.724174 1.48089 1.03375C1.19484 1.34333 1.03414 1.76321 1.03414 2.20102V28.6133C1.03414 29.0511 1.19484 29.471 1.48089 29.7805C1.76695 30.0901 2.15492 30.264 2.55946 30.264H20.8634C21.2679 30.264 21.6559 30.0901 21.9419 29.7805C22.228 29.471 22.3887 29.0511 22.3887 28.6133V2.20102C22.3887 1.76321 22.228 1.34333 21.9419 1.03375C21.6559 0.724174 21.2679 0.550255 20.8634 0.550255H2.55946ZM2.55946 0H20.8634C21.4027 0 21.92 0.231893 22.3014 0.644664C22.6828 1.05744 22.8971 1.61727 22.8971 2.20102V28.6133C22.8971 29.197 22.6828 29.7569 22.3014 30.1696C21.92 30.5824 21.4027 30.8143 20.8634 30.8143H2.55946C2.02007 30.8143 1.50278 30.5824 1.12137 30.1696C0.739967 29.7569 0.525696 29.197 0.525696 28.6133V2.20102C0.525696 1.61727 0.739967 1.05744 1.12137 0.644664C1.50278 0.231893 2.02007 0 2.55946 0V0Z",
    fill: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01572 21L19.5039 21",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01572 17L19.5039 17",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01572 13L19.5039 13",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7598 9H19.5039",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01572 25L19.5039 25",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.54771,
    y: 4.5,
    width: 4.80807,
    height: 5,
    stroke: "#A3A3A3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.066 24.5C29.066 30.0383 24.7241 34.5 19.4019 34.5C14.0798 34.5 9.73779 30.0383 9.73779 24.5C9.73779 18.9617 14.0798 14.5 19.4019 14.5C24.7241 14.5 29.066 18.9617 29.066 24.5Z",
    fill: "white",
    stroke: "#A3A3A3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4926 26.2307L17.7265 28.5383L23.3112 20.4614",
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosed);
export default __webpack_public_path__ + "static/media/closed.454eaa13588073dbfe7147716287c53b.svg";
export { ForwardRef as ReactComponent };